var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md container mx-auto p-8 bg-white rounded-lg rounded-l-none shadow-lg pb-0 md:pb-8"},[_c('BrokerSignUpForm',{attrs:{"display-password":false,"aggregatorId":_vm.aggregatorId}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e2b056c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Aggregator/AggregatorBrokerSignUp.vue
// module id = null
// module chunks = 